module.exports = __webpack_public_path__ + "static/img/buy-system-399.5e7255e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newimages/buy-system-399.png
// module id = AIYp
// module chunks = 48